import { useContext, useEffect, useState } from "react";
import AuthContext from "../Context/AuthProvider";
import { getPrescription, viewPrescriptionById } from "../API/PrescriptionApi";
import { getServiceDetails } from "../API/LinkedServicesApi";
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, Grid2, Tooltip, Typography } from "@mui/material";
import { useSnackbar } from "../Utility/UserMessageContext";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { formatAge } from "../Utility/Utility";
import MenuBar from "../common/MenuBar";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import { convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";


function PhysiotherapyPrescriptionReadOnly({ serviceId, prescriptionId, changeTabsLabel, uniqueTabId }) {
  const [errorMessage, setErrorMessage] = useState();
  const { auth } = useContext(AuthContext);
  const [prescriptionStatus, setPrescriptionStatus] = useState();
  const [currentService, setCurrentService] = useState();
  const displayText = (value, fallback = "Not available") => {
    return value !== undefined && value !== null ? value : fallback;
  };

  const [detailedPrescription, setDetailedPrescription] = useState();
  
  // Prescription data
  // const [complaint, setComplaint] = useState();
  // const [medicalHistoryNotes, setMedicalHistoryNotes] = useState();
  // const [medicalHistoryConditions, setMedicalHistoryConditions] = useState([]);
  // const [surgeryDetails, setSurgeryDetails] = useState();
  // const [painLevel, setPainLevel] = useState();
  // const [painTypes, setPainTypes] = useState([]);
  // const [rangeOfMotion, setRangeOfMotion] = useState();
  // const [muscleStrength, setMuscleStrength] = useState();
  // const [muscleTightness, setMuscleTightness] = useState();
  // const [specialTests, setSpecialTests] = useState();
  // const [treatmentPlan, setTreatmentPlan] = useState();
  // const [dosDonts, setDosDonts] = useState();
  // const [suggestedSessions, setSuggestedSessions] = useState();
  // const [shortTermTreatmentGoals, setShortTermTreatmentGoals] = useState();
  // const [longTermTreatmentGoals, setLongTermTreatmentGoals] = useState();
  // const [treatmentMethods, setTreatmentMethods] = useState([]);

  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const loadService = async (svcId) => {
      if (auth != null && svcId != null) {
        var result = await getServiceDetails(auth, svcId);
        if (result?.isSuccess) {
          setCurrentService(result?.data);
        } else {
          showSnackbar(result?.data, "error");
        }
      }
    };

    const loadPrescription = async () => {
      if (auth != null && prescriptionId != null) {
        var result = await getPrescription(auth, prescriptionId);
        if (result.isSuccess) {
          var prescription = result?.data;
          setPrescriptionStatus(prescription?.status);
          await loadService(prescription?.availedServiceId);
          var detailedPrescriptionJson = JSON.parse(
            prescription?.detailedPrescription
          );
          setDetailedPrescription(detailedPrescriptionJson);
          if (changeTabsLabel) {
            changeTabsLabel(uniqueTabId, `${prescription?.displayId}`);
          }
          // if (prescription?.detailedPrescription) {
          //   setComplaint(detailedPrescriptionJson?.complaint);
          //   setMedicalHistoryConditions(detailedPrescriptionJson?.medicalHistoryConditions);
          //   setMedicalHistoryNotes(detailedPrescriptionJson?.medicalHistoryNotes);
          //   setSurgeryDetails(detailedPrescriptionJson?.surgeryDetails);
          //   setPainLevel(detailedPrescriptionJson?.painLevel);
          //   setPainTypes(detailedPrescriptionJson?.painTypes);
          //   setRangeOfMotion(detailedPrescriptionJson?.rangeOfMotion);
          //   setMuscleStrength(detailedPrescriptionJson?.muscleStrength);
          //   setMuscleTightness(detailedPrescriptionJson?.muscleTightness);
          //   setSpecialTests(detailedPrescriptionJson?.specialTests);
          //   setTreatmentPlan(detailedPrescriptionJson?.treatmentPlan);
          //   setDosDonts(detailedPrescriptionJson?.dosDonts);
          //   setSuggestedSessions(detailedPrescriptionJson?.suggestedSessions);
          //   setShortTermTreatmentGoals(detailedPrescriptionJson?.shortTermTreatmentGoals);
          //   setLongTermTreatmentGoals(detailedPrescriptionJson?.longTermTreatmentGoals);
          //   setTreatmentMethods(detailedPrescriptionJson?.treatmentMethods);

          // }
        } else {
          showSnackbar(result?.data, "error");
        }
      }
    };
    
    loadService();
    loadPrescription();
  }, [auth, serviceId, prescriptionId]);


    let clinicalServiceCode = displayText(currentService?.serviceCode);
  let serviceName = displayText(currentService?.serviceName);

  let finalserviceName = clinicalServiceCode +" "+ serviceName;


  // Helper function to get selected items as a comma-separated string
  const getSelectedItems = (items) => {
    if (!items) return "";
    return items
      .filter(item => item.selected)
      .map(item => item.displayValue)
      .join(", ");
  };

  return (
    <>
      <Grid2 container size={12} >
        {/* <Grid2 container size={12}>
          <Grid2 container size={4} spacing={1} alignContent="center">
            {prescriptionStatus === "Final" && (
              <Tooltip title="Download as PDF">
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={viewPrescription}
                >
                  Download
                </Button>
              </Tooltip>
            )}
          </Grid2>
        </Grid2> */}
    <Grid2 container size={12}>
  {/* <Grid2 size={12}>
    <MenuBar 
      onDownload={viewPrescription}
      showDownload={prescriptionStatus === "Final"}  
      prescriptionStatus={prescriptionStatus}
    />
  </Grid2> */}
</Grid2>

        <Grid2 container size={12}>
          <Grid2
            size={{ sx: 12, sm: 12, md: 12, lg: 9, xl: 9 }}
            sx={{ paddingTop: "10px",padding: "10px", width: "100%" }}
          >
            <Card
              className="outerCard"
              variant="outlined"
              fullWidth
              sx={{ width: "100%", padding: "10px" }}
            >
              <Grid2 container spacing={1} size={12} sx={{ maxHeight: "calc(100vh - 200px)", overflowY: "auto"}}>
             <Grid2 size={12}>
                      <Grid2 container size={12}>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Patient Name"
                            value={
                              currentService?.patientPrefix +
                              " " +
                              currentService?.patientFirstName +
                              " " +
                              currentService?.patientLastName
                            }
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Age and Gender"
                            value={
                              formatAge(currentService?.patientAgeInYears) +
                              " and " +
                              currentService?.patientGender
                            }
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="MRN"
                            value={displayText(currentService?.patientMRN)}
                          />
                        </Grid2>
                      </Grid2>
                      <Grid2 container size={12}>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Visit Id"
                            value={displayText(currentService?.visitDisplayId)}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Visit Type"
                            value={displayText(currentService?.visitType)}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Visit Date Time"
                            value={convertUTCToTimeZoneDateTimeString(
                              new Date().toISOString(),
                              Intl.DateTimeFormat().resolvedOptions().timeZone
                            )}
                          />
                        </Grid2>
                      </Grid2>
                      <Grid2 container size={12}>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Service Id"
                            value={displayText(currentService?.displayId)}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Service Name"
                            value={finalserviceName}
                          />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}>
                          <HeaderValueDisplay
                            header="Service Date Time"
                            value={convertUTCToTimeZoneDateTimeString(
                              new Date().toISOString(),
                              Intl.DateTimeFormat().resolvedOptions().timeZone
                            )}
                          />
                        </Grid2>
                      </Grid2>
                    </Grid2>

                <Accordion defaultExpanded variant="outlined" sx={{ width: "100%", maxWidth: "100%" }}>
                  <AccordionSummary
                    expandIcon={<GridExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography component="span">
                      Complaint and Medical History
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "8px", position: "relative" }}>
                    <Grid2 container spacing={3} size={12} sx={{justifyContent:'center', paddingX:'10px'}}>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Chief Complaint</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.complaint}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Medical History</Typography>
                        <Typography variant="body1" paragraph>
                          {getSelectedItems(detailedPrescription?.medicalHistoryConditions)}
                        </Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Medical History Notes</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.medicalHistoryNotes}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Surgery Details</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.surgeryDetails}</Typography>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded variant="outlined" sx={{ width: "100%", maxWidth: "100%" }}>
                  <AccordionSummary
                    expandIcon={<GridExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography component="span">Assessment</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "8px", position: "relative" }}>
                    <Grid2 container spacing={3} size={12} sx={{justifyContent:'center', paddingX:'10px'}}>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Pain Level</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.painLevel} / 10</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Pain Level Notes</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.painLevelNotes}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Pain Types</Typography>
                        <Typography variant="body1" paragraph>{getSelectedItems(detailedPrescription?.painTypes)}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Pain Type Notes</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.painTypeNotes}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Range of Motion</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.rangeOfMotion}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Muscle Strength</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.muscleStrength}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Muscle spasm \ Tightness \ Trigger points</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.muscleTightness}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Special Test</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.specialTests}</Typography>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded variant="outlined" sx={{ width: "100%", maxWidth: "100%" }}>
                  <AccordionSummary
                    expandIcon={<GridExpandMoreIcon />}
                    aria-controls="panel3-content"
                    id="panel3-header"
                  >
                    <Typography component="span">Prescribed Treatment</Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: "8px", position: "relative" }}>
                    <Grid2 container spacing={3} size={12} sx={{justifyContent:'center', paddingX:'10px'}}>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Treatment Plan</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.treatmentPlan}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Suggested no. of sessions</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.suggestedSessions}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Short term treatment goals</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.shortTermTreatmentGoals}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Treatment Methods</Typography>
                        <Typography variant="body1" paragraph>
                          {detailedPrescription?.treatmentMethods
                            ?.filter(method => method.selected)
                            .map(method => {
                              if (method.value === "Others" && method.additionalText) {
                                return `${method.displayValue} (${method.additionalText})`;
                              }
                              return method.displayValue;
                            })
                            .join(", ")}
                        </Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Long term treatment goals</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.longTermTreatmentGoals}</Typography>
                      </Grid2>
                      <Grid2 size={12}>
                        <Typography variant="subtitle1" sx={{fontWeight: 'bold', mb: 1}}>Do's and Dont's</Typography>
                        <Typography variant="body1" paragraph>{detailedPrescription?.dosDonts}</Typography>
                      </Grid2>
                    </Grid2>
                  </AccordionDetails>
                </Accordion>
              </Grid2>
            </Card>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}

export default PhysiotherapyPrescriptionReadOnly;